module.exports = __webpack_public_path__ + "img/qr.84badbed.png";